document.addEventListener('DOMContentLoaded', function(){

  // sticky header
  const header = document.querySelector('.fn-header');
  const headerOffset = header.offsetTop;
  const headerHeight = header.clientHeight + headerOffset;

  const naviButtons = document.querySelectorAll('.fn-navi-button');
  const naviWrap = document.querySelector('.fn-navi-wrap');
  const toggleActive = (array) => array.forEach(target => target.classList.toggle('is-active'));
  if (naviWrap && naviButtons.length > 0) {
    naviButtons.forEach(button => {
      button.addEventListener('click', event => {
        toggleActive([naviWrap, event.currentTarget]);
      });
    });
  }

  const pageTopBtn = document.querySelector('.fn-pagetop');
  if (pageTopBtn) {
    pageTopBtn.addEventListener('click', function scrollUp() {
      const nowY = window.pageYOffset;
      window.scrollTo(0, Math.floor(nowY * 0.8));
      if (nowY > 0) {
        window.setTimeout(scrollUp, 10);
      }
    });
  }

  jQuery(function($) {
    // smooth scroll
    const offsetY = -headerHeight;
    const time = 500;

    $('.fn-smooth-link').click(function() {
      if (naviWrap.classList.contains('is-active')) {
        toggleActive([naviWrap, ...naviButtons]);
      }

      const target = $(this.hash);
      if (!target.length) return;
      const targetY = target.offset().top + offsetY;
      $('html,body').animate({ scrollTop: targetY }, time, 'swing');
      window.history.pushState(null, null, this.hash);
      return false;
    });

    if (document.querySelector('.fn-music-slider')) {
      $('.fn-music-slider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 4,
              centerPadding: '20px',
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
              centerPadding: '20px',
            }
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: true,
              variableWidth: true,
              slidesToShow: 1,
              centerPadding: '20px',
            }
          },
        ]
      });
    }

  });

}, false);
